import { _ as _defineProperty } from './defineProperty-2d1aa32d.js';
import { useContext, createContext } from 'react';
import { DEFAULT_CURRENCY } from './currencyService/index.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var dataInitialState = {
  currency: DEFAULT_CURRENCY,
  adyenKey: ''
};
var actionHandlers = {
  paymentInfo: function paymentInfo(_paymentInfo) {
    return {
      paymentInfo: _paymentInfo
    };
  },
  userOrder: function userOrder(_userOrder) {
    return {
      userOrder: _userOrder
    };
  },
  forceTier: function forceTier(_forceTier) {
    return {
      forceTier: _forceTier
    };
  },
  currency: function currency(_currency) {
    return {
      currency: _currency
    };
  },
  isGooglePayAvailable: function isGooglePayAvailable(_isGooglePayAvailable) {
    return {
      isGooglePayAvailable: _isGooglePayAvailable
    };
  },
  isApplePayAvailable: function isApplePayAvailable(_isApplePayAvailable) {
    return {
      isApplePayAvailable: _isApplePayAvailable
    };
  },
  activePlans: function activePlans(_activePlans) {
    return {
      activePlans: _activePlans
    };
  },
  selectedTier: function selectedTier(_selectedTier) {
    return {
      selectedTier: _selectedTier
    };
  },
  selectedPlan: function selectedPlan(_selectedPlan) {
    return {
      selectedPlan: _selectedPlan
    };
  },
  selectedPackage: function selectedPackage(_selectedPackage) {
    return {
      selectedPackage: _selectedPackage
    };
  },
  seatsCount: function seatsCount(_seatsCount) {
    return {
      seatsCount: _seatsCount
    };
  },
  frequency: function frequency(_frequency) {
    return {
      frequency: _frequency
    };
  },
  promoCode: function promoCode(_promoCode) {
    return {
      promoCode: _promoCode
    };
  },
  discountPercent: function discountPercent(_discountPercent) {
    return {
      discountPercent: _discountPercent
    };
  },
  extendedTrialDays: function extendedTrialDays(_extendedTrialDays) {
    return {
      extendedTrialDays: _extendedTrialDays
    };
  },
  savedPaymentData: function savedPaymentData(_savedPaymentData) {
    return {
      savedPaymentData: _savedPaymentData
    };
  },
  savedCardData: function savedCardData(_savedCardData) {
    return {
      savedCardData: _savedCardData
    };
  },
  premiumItems: function premiumItems(_premiumItems) {
    return {
      premiumItems: _premiumItems
    };
  },
  areTiersAvailable: function areTiersAvailable(_areTiersAvailable) {
    return {
      areTiersAvailable: _areTiersAvailable
    };
  },
  tiersCredits: function tiersCredits(_tiersCredits) {
    return {
      tiersCredits: _tiersCredits
    };
  },
  patch: function patch(data) {
    return data;
  }
};
var dataReducer = function dataReducer(prevState, _ref) {
  var type = _ref.type,
    payload = _ref.payload;
  var updatedState = actionHandlers[type](payload);
  return _objectSpread(_objectSpread({}, prevState), updatedState);
};
var DataStoreContext = /*#__PURE__*/createContext([dataInitialState, function () {}]);
var useDataStore = function useDataStore() {
  return useContext(DataStoreContext);
};

export { DataStoreContext as D, dataReducer as d, useDataStore as u };
//# sourceMappingURL=dataStore-426d2a71.js.map
